const DEVICE_SOFTWARE_LIST_SUCCESS = "DEVICE_SOFTWARE_LIST_SUCCESS";
const DEVICE_SOFTWARE_LIST_FAIL = "DEVICE_SOFTWARE_LIST_FAIL";
const DEVICE_SOFTWARE_CREATE_SUCCESS = "DEVICE_SOFTWARE_CREATE_SUCCESS";
const DEVICE_SOFTWARE_CREATE_FAIL = "DEVICE_SOFTWARE_CREATE_FAIL";
const DEVICE_SOFTWARE_CREATE_RESET = "DEVICE_SOFTWARE_CREATE_RESET";
const DEVICE_SOFTWARE_SELECTED_SUCCESS = "DEVICE_SOFTWARE_SELECTED_SUCCESS";
const DEVICE_SOFTWARE_SELECTED_FAIL = "DEVICE_SOFTWARE_SELECTED_FAIL";
const DEVICE_SOFTWARE_LOADED = "DEVICE_SOFTWARE_LOADED";
const DEVICE_SOFTWARE_UPDATE_SUCCESS = "DEVICE_SOFTWARE_UPDATE_SUCCESS";
const DEVICE_SOFTWARE_UPDATE_FAIL = "DEVICE_SOFTWARE_UPDATE_FAIL";
const DEVICE_SOFTWARE_GET_SUCCESS = "DEVICE_SOFTWARE_GET_SUCCESS";
const DEVICE_SOFTWARE_GET_FAIL = "DEVICE_SOFTWARE_GET_FAIL";
const DEVICE_SOFTWARE_DELETE_SUCCESS = "DEVICE_SOFTWARE_DELETE_SUCCESS";
const DEVICE_SOFTWARE_DELETE_FAIL = "DEVICE_SOFTWARE_DELETE_FAIL";
const MINIMUM_VERSIONS_GET_SUCCESS = "MINIMUM_VERSIONS_GET_SUCCESS";

export const defaultDeviceSoftwareState = {
  error: false,
  created: false,
  updated: false,
  software: null,
  softwares: null,
  softwareId: null,
  minimumVersions: null,
  errorMessage: null 
};

export default (state = defaultDeviceSoftwareState, action) => {
  switch (action.type) {
    case DEVICE_SOFTWARE_LIST_SUCCESS:
      return {
        ...state,
        softwares: action.payload.data
      };
    case DEVICE_SOFTWARE_LIST_FAIL:
      return {
        ...state,
        softwares: null
      };
    case DEVICE_SOFTWARE_CREATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          created: true,
          software: action.meta.previousAction.payload.request.data.request,
          softwareId: action.payload.data.id,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          created: false,
          error: true
        };
      }
    }
    case DEVICE_SOFTWARE_CREATE_FAIL:
      return {
        ...state,
        created: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case DEVICE_SOFTWARE_CREATE_RESET:
      return {
        ...state,
        created: false,
        software: null,
        softwareId: null,
        error: false
      };
    case DEVICE_SOFTWARE_SELECTED_SUCCESS:
      return {
        ...state,
        created: false,
        software: action.payload.data,
        softwareId: action.payload.data.id,
        error: false
      };
    case DEVICE_SOFTWARE_SELECTED_FAIL:
      return {
        ...state,
        created: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case DEVICE_SOFTWARE_LOADED: {
      return {
        ...state,
        created: false,
        software: action.data.software,
        softwareId: action.data.software.id,
        error: false
      };
    }

    case DEVICE_SOFTWARE_UPDATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          updated: true,
          softwareId: action.payload.data.id,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }

    case DEVICE_SOFTWARE_UPDATE_FAIL: {
      return {
        ...state,
        updated: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }

    case DEVICE_SOFTWARE_GET_SUCCESS: {
      return {
        ...state,
        software: action.payload.data,
        softwareId: action.payload.data.id
      };
    }
    case DEVICE_SOFTWARE_GET_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case DEVICE_SOFTWARE_DELETE_SUCCESS: {
      return {
        ...state
      };
    }
    case DEVICE_SOFTWARE_DELETE_FAIL: {
      return {
        ...state
      };
    }
    case MINIMUM_VERSIONS_GET_SUCCESS: {
      return {
        ...state,
        minimumVersions: action.payload.data
      };
    }
    default:
      return {
      ...state
    };
  }
};
